import React from "react";
import { CheckIcon, GlobeIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { valueStack } from "../../data/landing";
import { MOCKUP_URL } from "../../data/offer";
type Row = {
  name: string;
  value: number;
};
function Group({
  title,
  rows
}: {
  title: string;
  rows: Row[];
}) {
  return <div data-id="element-219" data-mp="3a3cko0mi1nmp">
      <p className="font-display text-sm font-bold uppercase tracking-wider text-coral" data-id="element-220" data-mp="3a3m93jrwbmqa">{title}</p>
      <ul className="mt-2 divide-y divide-navy/10" data-id="element-221" data-mp="3f27517047k8x">
        {rows.map(r => <li key={r.name} className="flex items-start justify-between gap-4 py-3" data-id="element-222" data-mp="3jxcx6nk41v5g">
            <span className="flex items-start gap-2.5 text-[15px] font-bold leading-snug text-ink" data-id="element-223" data-mp="3nwbw9rj5uxoz">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint" strokeWidth={3} aria-hidden="true" data-id="element-224" data-mp="3sxrl7uoglocn" />
              {r.name}
            </span>
            <span className="shrink-0 text-[15px] font-bold text-ink/60" data-id="element-225" data-mp="1klzsp6mxnijn">${r.value}</span>
          </li>)}
      </ul>
    </div>;
}
export function Offer() {
  return <Section id="offer" className="bg-navy" data-id="element-226" data-mp="1foq3ns3gh8wc">
      <SectionHeading tone="dark" eyebrow="Your promotional offer" title="Get the complete Pediatric Articulation Clinical Blueprint™ collection" intro="Everything you need to organize your speech sound planning resources in one place." data-id="element-227" data-mp="1bltibtmj6yop" />

      <div className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-[32px] bg-white shadow-[0_24px_60px_rgba(0,0,0,0.3)]" data-id="element-228" data-mp="1z9uo4usbs10f">
        <div className="bg-sky-soft px-3 pt-3" data-id="element-229" data-mp="1uicwixc6zcs4">
          <img src={MOCKUP_URL} alt="All six volumes and five bonuses" className="mx-auto h-auto w-full max-w-md" data-id="element-230" data-mp="1pkkuvblqwcaq" />
        </div>
        <div className="space-y-6 p-5 sm:p-10" data-id="element-231" data-mp="2n072ane5ytzg">
          <Group title="The six-volume collection" rows={valueStack.volumes} data-id="element-232" data-mp="2n21os6532u5n" />
          <Group title="Your five exclusive bonuses" rows={valueStack.bonuses} data-id="element-233" data-mp="2i7nqnvz1e8xa" />

          <div className="rounded-2xl bg-cream p-5 text-center" data-id="element-234" data-mp="316ijgl9kqoh1">
            <p className="text-[15px] font-extrabold uppercase tracking-wide text-ink/70" data-id="element-235" data-mp="364ali83xnqyy">
              Total suggested reference value: <span className="line-through" data-id="element-236" data-mp="2sdynxtokx00f">$203</span>
            </p>
            <p className="mt-2 font-display text-xl font-bold uppercase text-navy" data-id="element-237" data-mp="2weinf3wmkfpq">Your price today</p>
            <p className="font-display text-[80px] font-bold leading-none text-coral" data-id="element-238" data-mp="2if95nzsrtdjn">$27</p>
            <p className="mt-1 text-sm font-extrabold uppercase text-ink/70" data-id="element-239" data-mp="2ne2j5s8254jt">USD · One-time payment</p>
            <p className="mx-auto mt-3 max-w-md text-[15px] leading-relaxed text-ink/80" data-id="element-240" data-mp="29ekrn53dnd6r">
              Get the complete six-volume collection and all five bonuses for one payment of $27. No monthly
              membership is required.
            </p>
          </div>

          <CTAButton label="Get instant access now" note="One-time payment · Instant digital access" data-id="element-241" data-mp="7ktv6h5xub7w" />
          <Countdown data-id="element-242" data-mp="bmfeak92flqj" />
          <ScarcityBar data-id="element-243" data-mp="1w6aty80fr4sq" />

          <div className="flex items-start gap-3 rounded-2xl bg-sky-soft p-4" data-id="element-244" data-mp="1w5srgtn6jucd">
            <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-sky" aria-hidden="true" data-id="element-245" data-mp="1s58p9bnr20jd" />
            <p className="text-[15px] font-bold leading-snug text-ink" data-id="element-246" data-mp="25wdnc9bgykrl">
              Automatic currency conversion: the price is converted to your local currency at checkout.
            </p>
          </div>

          <p className="text-center text-xs leading-relaxed text-ink/60" data-id="element-247" data-mp="2fub8gny181fz">
            Reference values are illustrative offer comparisons, not independently verified market prices.
          </p>
        </div>
      </div>
    </Section>;
}